"use strict";

import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import { AppDispatcher } from 'Dispatcher';
import StoreClass from 'Store';
import { FormFilterConstants } from 'Constants/Forms/FormFilterConstants';
import { ApplicationConstants } from "Constants/ApplicationConstants";
import { Fields, System } from "Constants/objects";
import { Map, Record } from "immutable";
import { Model } from "Model";
import { formDestroyed } from "Actions/Forms/FormActions";
import { formFilterApply, formFilterUpdate } from "Actions/Forms/FormFilterActions";
import { d5TableFilterSaved } from "Actions/Table/D5TableActions";
import { Messages } from "Messages";
import { checkIfUserScriptExists, createTableID, formatDateToAPI, formatText, getAddSSFilter, getSelectFieldData, getSSTableCols, getTitlePosition, isDateByTypeStr, isEmptyValue, setAddSSFilter, setSSTableCols } from "D5Utils/functions";
import FormFilterEditor from "D5Utils/filter_editor/FormFilterEditor";
import { loadFilterFields, loadFormFields, loadFormFilterFieldEvents, loadFormMetadata } from "D5Utils/common_requests";
import { UserScriptModel } from "UserActionHandler/UserScriptModel";
import { showSnackBar } from "Actions/D5SnackbarsActions";
var FilterStore = Record({
  formID: null,
  rowID: null,
  type: null,
  initialized: false,
  title: '',
  name: '',
  objectName: '',
  objectFields: null,
  fieldGroupsData: null,
  formInst: null,
  popupInst: null,
  viewMode: System.VIEW_MODE.MODAL,
  updating: false,
  lsKey: '',
  tableUUID: '',
  formData: null,
  formEditors: new window.Map(),
  formFields: [],
  filterEvents: [],
  formName: ''
});

var _stores = Map();

var CHANGE_EVENT = 'change';

var FormFilterStoreClass =
/*#__PURE__*/
function (_StoreClass) {
  _inherits(FormFilterStoreClass, _StoreClass);

  function FormFilterStoreClass() {
    _classCallCheck(this, FormFilterStoreClass);

    return _possibleConstructorReturn(this, _getPrototypeOf(FormFilterStoreClass).apply(this, arguments));
  }

  _createClass(FormFilterStoreClass, [{
    key: "getInitList",
    value: function getInitList() {
      return new FilterStore().toObject();
    }
    /**
     * @return {*|Map<any, any>|Map<string, string>}
     */

  }, {
    key: "getList",
    value: function getList(uuid) {
      return _stores.get(uuid).toObject();
    }
  }, {
    key: "getFieldByName",
    value: function getFieldByName(name, UUID) {
      var objectFields = _stores.get(UUID).get('objectFields');

      return _.find(objectFields, function (item) {
        return item.Name === name;
      });
    }
  }, {
    key: "isLookup",
    value: function isLookup(field, UUID) {
      return this.getLinkedName(field, UUID) && this.getDisplayObjectFieldIDName(field, UUID);
    }
  }, {
    key: "navigateToParent",
    value: function navigateToParent(UUID) {
      setTimeout(function () {
        return formDestroyed(UUID);
      });
    }
  }, {
    key: "prepareFormData",
    value: function prepareFormData(UUID) {
      var _this = this;

      var store = _stores.get(UUID);

      var lsKey = this.lsKey(UUID);
      var lsColumns = getSSTableCols(lsKey);
      var addFilter = getAddSSFilter(lsKey);
      var formData = store.get('formData');
      var formEditors = this.getFormEditors(UUID);

      var objectFields = _stores.get(UUID).get('objectFields');

      _.each(objectFields, function (field) {
        var editor = formEditors.get(field.Name);
        if (!editor) return;

        var tableField = _this.isTableField(field, UUID);

        var dataField = field[Fields.Name];
        var realOperation = editor.operation();
        var filterValue = formData[dataField];

        if (isDateByTypeStr(editor.type())) {
          if (Array.isArray(filterValue)) {
            filterValue = filterValue.map(function (date) {
              return formatDateToAPI(new Date(date));
            });
          } else {
            if (filterValue != null) filterValue = formatDateToAPI(new Date(filterValue));
          }
        } else if (editor.type() === 'boolean') {
          filterValue = filterValue != null ? Number(filterValue) : filterValue;
        }

        if (tableField) {
          var col = _this.getLSColumnByName(lsColumns, tableField.Name);

          col.realOperation = realOperation;
          col.filterValue = filterValue;
        } else {
          if (addFilter[dataField]) {
            if (isEmptyValue(filterValue)) {
              delete addFilter[dataField];
            } else {
              addFilter[dataField].filterValue = filterValue;
            }
          } else {
            if (!isEmptyValue(filterValue)) {
              addFilter[dataField] = {
                realOperation: realOperation,
                filterValue: filterValue
              };
            }
          }
        }
      });

      return {
        lsColumns: lsColumns,
        addFilter: addFilter
      };
    }
  }, {
    key: "getFieldType",
    value: function getFieldType(field, UUID) {
      var fieldType = this.getObjectFieldType(field, UUID);
      if (this.isLookup(field, UUID)) return System.DX_CONTROLS.dxTagBox;

      switch (fieldType) {
        case System.FIELD_TYPE.NUMBER:
          return System.DX_CONTROLS.dxNumberBox;

        case System.FIELD_TYPE.DATE:
          return System.DX_CONTROLS.dxDateBox;

        case System.FIELD_TYPE.BOOL:
          return System.DX_CONTROLS.dxCheckBox;

        case System.FIELD_TYPE.BUTTON:
          return System.DX_CONTROLS.dxButton;

        default:
          return System.DX_CONTROLS.dxTextBox;
      }
    } //TODO Move to 'FilterClass' -----------------------------------------------------------------------------

  }, {
    key: "lsKey",
    value: function lsKey(UUID) {
      var store = _stores.get(UUID);

      return store.get('lsKey');
    }
  }, {
    key: "getLSColumnByName",
    value: function getLSColumnByName(lsCols, name) {
      return lsCols.find(function (col) {
        return col.dataField === name;
      });
    }
  }, {
    key: "filterToFormData",
    value: function filterToFormData(UUID) {
      var _this2 = this;

      var data = {};

      var store = _stores.get(UUID);

      var fields = store.get('objectFields');
      var lsColumns = getSSTableCols(this.lsKey(UUID));
      var addFilter = getAddSSFilter(this.lsKey(UUID));

      _.each(fields, function (field) {
        var tableField = _this2.isTableField(field, UUID);

        if (tableField) {
          var col = _this2.getLSColumnByName(lsColumns, tableField.Name);

          data[field.Name] = col ? col.filterValue : undefined;
        } else {
          data[field.Name] = addFilter[field.Name] && addFilter[field.Name].filterValue;
        }
      });

      return data;
    }
  }, {
    key: "saveFilter",
    value: function saveFilter(UUID, lsColumns, addFilter) {
      var store = _stores.get(UUID);

      var lsKey = this.lsKey(UUID);
      lsColumns.forEach(function (col) {
        if (isEmptyValue(col.filterValue)) delete col.filterValue;
      });
      setSSTableCols(lsKey, lsColumns);
      setAddSSFilter(lsKey, addFilter);
      d5TableFilterSaved({
        formUUID: store.get('tableUUID'),
        sender: System.FILTER_SENDERS.FORM
      });
    } //TODO Move to 'FilterClass' ---------------------------------------------------------------------------

  }, {
    key: "initForm",
    value: function initForm(_ref) {
      var UUID = _ref.UUID;
      var items = this.prepareFields(UUID);

      var store = _stores.get(UUID);

      var that = this;
      var data = this.filterToFormData(UUID);
      store = store.set('formData', data);
      _stores = _stores.set(UUID, store);
      var form = $(store.get('formInst')).dxForm({
        formData: data,
        items: [items],
        labelLocation: 'left',
        tabIndex: -1,
        onInitialized: function onInitialized(e) {},
        onEditorEnterKey: function onEditorEnterKey(e) {
          if (e.event.ctrlKey && e.event.keyCode === 13) {
            //Ctrl+Enter
            e.component.getEditor(e.dataField).blur(); //для того чтобы обновилось значение поля

            formFilterApply(UUID);
          }
        },
        onContentReady: function onContentReady(e) {
          var _this3 = this;

          //таймаут потому что форма загружается раньше чем показывается попап, взято из примера поддержки либы
          setTimeout(function () {
            var store = _stores.get(UUID);

            var $elements = _this3.element().find('input,select,textarea');

            $("#fe-title-".concat(UUID)).html(store.get('title'));

            for (var i = 0; i < $elements.length; ++i) {
              var editor = _this3.getEditor($elements[i].name);

              if (editor && !editor.option('disabled') && editor.option('visible')) {
                editor.focus();
                break;
              }
            }

            function labelClick(e) {
              var input = $("#".concat($(e.currentTarget).attr('for')));
              input.trigger('focus');
              input.trigger('select');
            }

            var $labels = $('.dx-field-item-label');
            $labels.off('click', labelClick);
            $labels.on('click', labelClick);
            store = store.set('initialized', true);
            _stores = _stores.set(UUID, store);
            that.emit(CHANGE_EVENT);
          }, 600);
        },
        onDisposing: function onDisposing(e) {}
      });
      store = store.set('formInst', form);

      if (store.get('popupInst')) {
        store.get('popupInst').dxPopup("show");
      }

      _stores = _stores.set(UUID, store);
    }
  }, {
    key: "createFieldsGroup",
    value: function createFieldsGroup() {
      return {
        itemType: 'group',
        colCount: 1,
        items: []
      };
    }
  }, {
    key: "getLinkedName",
    value: function getLinkedName(field, UUID) {
      return this.isTableField(field, UUID) ? field[Fields.ObjectFieldID_LinkedObjectID_Name] : field[Fields.LinkedObjectID_Name];
    }
  }, {
    key: "getKeyObjFieldName",
    value: function getKeyObjFieldName(field, UUID) {
      return this.isTableField(field, UUID) ? field[Fields.ObjectFieldID_KeyObjectFieldID_Name] : field[Fields.LinkedObjectID_KeyObjectFieldID_Name];
    }
  }, {
    key: "getDisplayObjectFieldIDName",
    value: function getDisplayObjectFieldIDName(field, UUID) {
      return this.isTableField(field, UUID) ? field[Fields.ObjectFieldID_DisplayObjectFieldID_Name] : field[Fields.LinkedObjectID_DisplayObjectFieldID_Name];
    }
  }, {
    key: "getObjectFieldType",
    value: function getObjectFieldType(field, UUID) {
      return (this.isTableField(field, UUID) ? field[Fields.ObjectFieldID_FieldType] : field[Fields.LinkedObjectID_DisplayObjectFieldID_FieldType]) || field[Fields.FieldType];
    }
  }, {
    key: "isTableField",
    value: function isTableField(field, UUID) {
      var formFields = _stores.get(UUID).get('formFields');

      return _.find(formFields, function (item) {
        return item[Fields.ObjectFieldID] === field[Fields.ObjectFieldID];
      });
    }
  }, {
    key: "addFieldsToGroup",
    value: function addFieldsToGroup(group, UUID) {
      var _this4 = this;

      var setFilterField = function setFilterField(field) {
        return {
          label: {
            text: window.D5.isDebugMode() ? "".concat(field[Fields.Title], " {").concat(field[Fields.Name], "}") : field[Fields.Title],
            location: getTitlePosition(field),
            visible: Boolean(field[Fields.IsShowTitle]),
            showColon: getTitlePosition(field) !== 'right'
          },
          Order: field.Order,
          visible: Boolean(field.IsVisible),
          dataField: field.Name,
          template: function template(data, itemElement) {
            var component = data.component,
                dataField = data.dataField;

            _this4.initField(field, component, dataField, itemElement, UUID);
          }
        };
      };

      var store = _stores.get(UUID);

      var objectFields = _.sortBy(store.get('objectFields'), Fields.Order); //перебор настроек полей


      _.each(objectFields, function (field) {
        group['items'].push(setFilterField(field));
      });
    }
  }, {
    key: "updateEditors",
    value: function updateEditors(UUID, data) {
      try {
        this.updating(UUID, true);
        var editors = this.getFormEditors(UUID);

        for (var fieldName in data) {
          if (data.hasOwnProperty(fieldName) && editors.has(fieldName)) {
            var editor = editors.get(fieldName);
            var value = data[fieldName];
            editor.setValue(value);
          }
        }
      } finally {
        this.updating(UUID, false);
      }
    }
  }, {
    key: "initField",
    value: function initField(field, formInst, dataField, itemElement, UUID) {
      var _this5 = this;

      var typeField = this.getFieldType(field, UUID);
      var dictObj = this.getLinkedName(field, UUID);
      var dictKeyFld = this.getKeyObjFieldName(field, UUID);
      var dictDisplayFld = this.getDisplayObjectFieldIDName(field, UUID);

      var type = function () {
        if (_this5.isLookup(field, UUID)) {
          return field[Fields.IsMultiselect] ? System.FIELD_EDITOR_TYPE.MULTI_SELECT : System.FIELD_EDITOR_TYPE.SELECT;
        }

        switch (typeField) {
          case System.DX_CONTROLS.dxCheckBox:
            return System.FIELD_EDITOR_TYPE.BOOL_CB;

          case System.DX_CONTROLS.dxNumberBox:
            return System.FIELD_EDITOR_TYPE.NUMBER;

          case System.DX_CONTROLS.dxDateBox:
            {
              return System.FIELD_EDITOR_TYPE.DATE;
            }

          case System.DX_CONTROLS.dxTextBox:
            return System.FIELD_EDITOR_TYPE.TEXT;
        }
      }();

      var store = _stores.get(UUID);

      var lsKey = this.lsKey(UUID);
      var lsColumns = getSSTableCols(lsKey);
      var addFilter = getAddSSFilter(lsKey);
      var realOperation = '';
      var allowFiltering = true;
      var tableField = this.isTableField(field, UUID);

      if (tableField) {
        var col = this.getLSColumnByName(lsColumns, tableField.Name);
        realOperation = col.realOperation;
        if (col.allowFiltering != null) allowFiltering = col.allowFiltering;
      } else {
        realOperation = addFilter[field.Name] && addFilter[field.Name].realOperation;
      }

      var initDropDown = function initDropDown(e) {
        setTimeout(function () {
          var $overlay = $('.dx-dropdowneditor-overlay'),
              $popupContent = $overlay.find('.dx-popup-content');
          $popupContent.css({
            'max-height': '278px'
          });
        });
      };

      var updateTable = function updateTable(value) {
        var store = _stores.get(UUID);

        var formData = store.get('formData');
        var val = value;

        if (isDateByTypeStr(type) && val) {
          if (typeof val === 'string') {
            val = new Date(val);
          } else if (Array.isArray(val)) {
            val = val.map(function (date) {
              return typeof date === 'string' ? new Date(date) : date;
            });
          }
        }

        formData[dataField] = val;
        _stores = _stores.set(UUID, store.set('formData', formData));
        formInst.updateData(dataField, value);
      };

      var fValue = formInst.option('formData')[dataField];

      if (type === System.FIELD_EDITOR_TYPE.DATE && fValue) {
        if (Array.isArray(fValue) && realOperation !== 'between') {
          fValue = fValue.map(function (date) {
            return formatText(System.FIELD_EDITOR_TYPE.DATE, date);
          });
        }
      }

      var props = {
        dataField: dataField,
        objectName: _stores.get(UUID).get('objectName'),
        dType: type,
        _id: "form-".concat(dataField),
        dataSource: this.createSelectFieldDS({
          dictObj: dictObj,
          dictKeyFld: dictKeyFld,
          dictDisplayFld: dictDisplayFld,
          UUID: UUID
        }),
        displayExpr: dictDisplayFld,
        valueExpr: dictKeyFld,
        disabled: !allowFiltering,
        value: fValue,
        onValueChanged: function onValueChanged(_ref2) {
          var value = _ref2.value;
          if (_this5.updating(UUID)) return;

          var eventName = _this5.getFilterFieldEventNameByField(field[Fields.ID], System.USER_EVENT_TYPE.ON_VALUE_CHANGED, UUID);

          var _this5$prepareFormDat = _this5.prepareFormData(UUID),
              lsColumns = _this5$prepareFormDat.lsColumns,
              addFilter = _this5$prepareFormDat.addFilter;

          if (tableField) {
            var lsCol = _.find(lsColumns, function (c) {
              return c.dataField === tableField.Name;
            });

            lsCol.filterValue = value;
          } else {
            if (addFilter[dataField]) {
              addFilter[dataField].filterValue = value;
            } else {
              addFilter[dataField] = {
                realOperation: '=',
                filterValue: value
              };
            }
          }

          if (eventName && checkIfUserScriptExists(_this5.getFormName(UUID), eventName)) {
            _this5.emitFilterFieldUserEvent({
              eventName: eventName,
              lsColumns: lsColumns,
              addFilter: addFilter,
              formUUID: UUID
            }).then(function (data) {
              if (data.hasOwnProperty('errorMessage')) {
                showSnackBar({
                  type: System.SNACKBAR_TYPES.Error,
                  message: data.errorMessage
                });
              } else {
                var fData = {};

                for (var name in data) {
                  if (data.hasOwnProperty(name)) {
                    fData[name] = data[name].filterValue;

                    _this5.updateOperation({
                      fieldName: name,
                      operation: data[name].realOperation,
                      UUID: UUID
                    });
                  }
                }

                _stores = _stores.set(UUID, store.set('formData', fData));
                formInst.updateData(fData);

                _this5.updateEditors(UUID, fData);
              }
            });

            return;
          }

          updateTable(value);
        },
        onOpened: function onOpened(e) {
          if (type === System.FIELD_EDITOR_TYPE.SELECT || type === System.FIELD_EDITOR_TYPE.MULTI_SELECT) initDropDown(e);
        },
        onContentReady: function onContentReady(e) {
          if (type === System.FIELD_EDITOR_TYPE.SELECT || type === System.FIELD_EDITOR_TYPE.MULTI_SELECT) initDropDown(e);
        }
      };
      var editor = new FormFilterEditor({
        defOperation: realOperation,
        type: type,
        onOperationChanged: function onOperationChanged(operation) {}
      }, props);
      editor.render();
      var el = editor.element();

      if (type === System.FIELD_EDITOR_TYPE.SELECT || type === System.FIELD_EDITOR_TYPE.MULTI_SELECT || type === System.FIELD_EDITOR_TYPE.BOOL_CB) {
        $(el).css('padding-left', '28px');
      }

      el.appendTo(itemElement);
      store = _stores.get(UUID);
      var formEditors = this.getFormEditors(UUID);
      formEditors.set(dataField, editor);
      _stores = _stores.set(UUID, store.set('formEditors', formEditors));
    }
  }, {
    key: "getFilterFieldEventNameByField",
    value: function getFilterFieldEventNameByField(fieldID, eventType, UUID) {
      var fieldEvent = this.getFilterEvents(UUID).find(function (e) {
        return e[Fields.FormFilterFieldID] === Number(fieldID) && e[Fields.EventTypeID] === eventType;
      });
      if (fieldEvent && fieldEvent[Fields.FunctionName]) return fieldEvent[Fields.FunctionName];
    }
  }, {
    key: "getLSName",
    value: function getLSName(UUID) {
      var formID = _stores.get(UUID).get('formID');

      return createTableID(formID);
    }
  }, {
    key: "getFormName",
    value: function getFormName(UUID) {
      return _stores.get(UUID).get('formName');
    }
  }, {
    key: "getFormFilters",
    value: function getFormFilters(UUID) {
      return _stores.get(UUID).get('objectFields');
    }
  }, {
    key: "getFormFields",
    value: function getFormFields(UUID) {
      return _stores.get(UUID).get('formFields');
    }
  }, {
    key: "getFormEditors",
    value: function getFormEditors(UUID) {
      return _stores.get(UUID).get('formEditors');
    }
  }, {
    key: "updateOperation",
    value: function updateOperation(_ref3) {
      var fieldName = _ref3.fieldName,
          operation = _ref3.operation,
          UUID = _ref3.UUID;
      var editor = this.getFormEditors(UUID).get(fieldName);
      if (editor) editor.operation(operation);
    }
  }, {
    key: "emitFilterFieldUserEvent",
    value: function () {
      var _emitFilterFieldUserEvent = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(_ref4) {
        var _this6 = this;

        var eventName, formUUID, lsColumns, addFilter, propsToFormData, model, newModel, props;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                eventName = _ref4.eventName, formUUID = _ref4.formUUID, lsColumns = _ref4.lsColumns, addFilter = _ref4.addFilter;

                propsToFormData = function propsToFormData(_ref5) {
                  var filter = _ref5.filter;
                  var out = {};

                  var _ref6 = filter.filter || {},
                      lsColumns = _ref6.lsColumns,
                      addFilter = _ref6.addFilter;

                  var formFilters = _this6.getFormFilters(formUUID);

                  var lsCols = _.indexBy(lsColumns, Fields.ObjectFieldID);

                  formFilters.forEach(function (field) {
                    var dataFieldFilter = field.Name;

                    if (addFilter.hasOwnProperty(dataFieldFilter)) {
                      out[dataFieldFilter] = {
                        filterValue: addFilter[dataFieldFilter].filterValue,
                        realOperation: addFilter[dataFieldFilter].realOperation
                      };
                    } else {
                      var lsCol = lsCols[field[Fields.ObjectFieldID]];

                      if (lsCol) {
                        out[dataFieldFilter] = {
                          filterValue: lsCol.filterValue,
                          realOperation: lsCol.realOperation
                        };
                      }
                    }
                  });
                  return out;
                };

                model = new UserScriptModel(this.getFormFields(formUUID), {}, {
                  filter: {
                    formFields: this.getFormFields(formUUID),
                    viewSource: this.getFormFilters(formUUID),
                    lsColumns: lsColumns,
                    addFilter: addFilter
                  }
                }, System.USER_SCRIPTS_INITIATOR.TABLE);
                _context.prev = 3;
                newModel = window[this.getFormName(formUUID)][eventName](model);

                if (!(newModel instanceof Promise)) {
                  _context.next = 9;
                  break;
                }

                newModel.then(function (data) {
                  var props = data.getProps();
                  return propsToFormData(props);
                }).catch(function (e) {
                  return {
                    errorMessage: e.message
                  };
                });
                _context.next = 11;
                break;

              case 9:
                props = newModel.getProps();
                return _context.abrupt("return", propsToFormData(props));

              case 11:
                _context.next = 16;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](3);
                return _context.abrupt("return", {
                  errorMessage: _context.t0.message
                });

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[3, 13]]);
      }));

      function emitFilterFieldUserEvent(_x) {
        return _emitFilterFieldUserEvent.apply(this, arguments);
      }

      return emitFilterFieldUserEvent;
    }()
  }, {
    key: "prepareFields",
    value: function prepareFields(UUID) {
      var group = this.createFieldsGroup();
      this.addFieldsToGroup(group, UUID);
      return group;
    }
    /**
     * @param {object} options
     */

  }, {
    key: "createSelectFieldDS",
    value: function createSelectFieldDS(options) {
      var dictObj = options.dictObj,
          dictKeyFld = options.dictKeyFld,
          dictDisplayFld = options.dictDisplayFld;
      if (!(dictObj && dictKeyFld && dictDisplayFld)) return;
      return new DevExpress.data.DataSource({
        paginate: true,
        pageSize: 10,
        store: new DevExpress.data.CustomStore({
          load: function load(loadOptions) {
            return getSelectFieldData(loadOptions, dictObj, dictKeyFld, dictDisplayFld);
          },
          byKey: function byKey(key) {
            if (Array.isArray(key) && !key.length) return Promise.resolve();
            return new Promise(function (resolve) {
              var ObjectModel = Model.extend({
                initialize: function initialize() {
                  this.object = dictObj;
                }
              });
              new ObjectModel().fetch({
                data: {
                  Columns: [dictKeyFld, dictDisplayFld],
                  Filters: _defineProperty({}, dictKeyFld, {
                    '=': key
                  }),
                  Sorts: [dictDisplayFld]
                },
                success: function success(res) {
                  resolve(res.toJSON());
                }
              });
            });
          }
        })
      });
    }
  }, {
    key: "updateForm",
    value: function updateForm(_ref7) {
      var UUID = _ref7.UUID,
          nextData = _ref7.nextData;

      var store = _stores.get(UUID);

      store.get('formInst').dxForm('option', 'formData', nextData);
      store = store.set('formData', nextData);
      _stores = _stores.set(UUID, store);
    }
  }, {
    key: "cancelForm",
    value: function cancelForm(UUID) {
      var store = _stores.get(UUID);

      if (store.get('viewMode') === System.VIEW_MODE.MODAL) store.get('popupInst').dxPopup('hide');
      FormFilterStore.navigateToParent(UUID);
    }
  }, {
    key: "applyFilter",
    value: function applyFilter(_ref8) {
      var UUID = _ref8.UUID;

      var _this$prepareFormData = this.prepareFormData(UUID),
          lsColumns = _this$prepareFormData.lsColumns,
          addFilter = _this$prepareFormData.addFilter;

      this.saveFilter(UUID, lsColumns, addFilter);
      this.cancelForm(UUID);
    }
  }, {
    key: "validateForm",
    value: function validateForm() {
      try {
        var validation = DevExpress.validationEngine.validateGroup("fieldToGroup");
        return validation.isValid;
      } catch (e) {
        return true;
      }
    }
  }, {
    key: "getFilterEvents",
    value: function getFilterEvents(UUID) {
      return _stores.get(UUID).get('filterEvents');
    }
  }, {
    key: "updating",
    value: function updating(UUID, value) {
      if (typeof value === 'undefined') {
        return _stores.get(UUID).get('updating');
      }

      var store = _stores.get(UUID);

      _stores = _stores.set(UUID, store.set('updating', value));
    }
  }, {
    key: "destroy",
    value: function destroy(UUID) {
      if (UUID != null) _stores.delete(UUID);else _stores.clear();
    }
  }]);

  return FormFilterStoreClass;
}(StoreClass);

var FormFilterStore = new FormFilterStoreClass();
AppDispatcher.register(function (action) {
  var st = FormFilterStore;
  var store = {};

  switch (action.actionType) {
    case FormFilterConstants.FORM_FILTER_INITIALIZE:
      var _action$formObj = action.formObj,
          formID = _action$formObj.formID,
          UUID = _action$formObj.UUID,
          viewMode = _action$formObj.viewMode,
          addData = _action$formObj.additionalData,
          objectName = _action$formObj.objectName;
      var objName = objectName || addData.formFilters.length && addData.formFilters[0][Fields.FormID_ObjectID_Name];
      _stores = _stores.set(UUID, new FilterStore({
        formID: formID,
        viewMode: viewMode,
        formInst: action.formInst,
        popupInst: action.popupInst,
        tableUUID: addData.UUID,
        lsKey: addData.lsKey,
        objectName: objName,
        title: Messages.Controls.Filter,
        formFields: addData.viewSource,
        objectFields: addData.formFilters
      }));

      if (addData.formFilters && addData.viewSource) {
        loadFormFilterFieldEvents(addData.formFilters.map(function (f) {
          return f.ID;
        })).then(function (events) {
          store = _stores.get(UUID);
          store = store.set('filterEvents', events);
          store = store.set('formName', addData.viewSource[0][Fields.FormID_Name]);
          _stores = _stores.set(UUID, store);
          formFilterUpdate({
            UUID: UUID
          });
        });
        return;
      }

      loadFormMetadata(formID).then(function (form) {
        var objID = form[Fields.ObjectID];
        Promise.all([loadFilterFields({
          id: objID,
          filter: _defineProperty({}, Fields.FormID, formID)
        }), loadFormFields(formID)]).then(function (data) {
          var filterFields = data[0];
          var formFields = data[1];
          store = _stores.get(UUID);
          store = store.set('objectFields', filterFields);
          store = store.set('formFields', formFields);

          if (filterFields.length) {
            _stores = _stores.set(UUID, store.set('objectName', filterFields[0][Fields.FormID_ObjectID_Name]));
          }

          loadFormFilterFieldEvents(filterFields.map(function (f) {
            return f.ID;
          })).then(function (events) {
            store = store.set('filterEvents', events);
            store = store.set('formName', formFields[0][Fields.FormID_Name]);
            _stores = _stores.set(UUID, store);
            formFilterUpdate({
              UUID: UUID
            });
          });
        });
      });
      break;

    case FormFilterConstants.FORM_FILTER_NAVIGATE_TO_PARENT:
      store = _stores.get(action.UUID);
      FormFilterStore.cancelForm(action.UUID);
      break;

    case FormFilterConstants.FORM_FILTER_UPDATE:
      if ($(_stores.get(action.UUID).get('formInst')).data('dxForm')) {
        st.updateForm(action);
      } else {
        st.initForm(action);
      }

      store = _stores.get(action.UUID);
      _stores = _stores.set(action.UUID, store.set('updating', false));
      break;

    case FormFilterConstants.FORM_FILTER_APPLY:
      if (FormFilterStore.validateForm()) FormFilterStore.applyFilter(action);
      break;

    case ApplicationConstants.DO_LOGOUT:
      {
        FormFilterStore.destroy();
        break;
      }

    default:
      return true;
  }
});
export default FormFilterStore;